import { useTranslation } from "@flare/i18n";

import { IntakeScheduler } from "@/components/Funnel/IntakeScheduler/IntakeScheduler";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { InputsContainer } from "../components/inputs-container";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepSubtitle } from "../components/step-subtitle";
import { StepTitle } from "../components/step-title";

export default function CreateMeeting() {
  const { t } = useTranslation();

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <StepTitle className="md:mt-10">
            {t("FUNNEL_INTAKE_SCHEDULER_TITLE")}
          </StepTitle>
          <StepSubtitle className="mb-0 mt-1">
            {t("FUNNEL_INTAKE_SCHEDULER_SUBTITLE")}
          </StepSubtitle>
          <InputsContainer className="mb-sp-4 mt-sp-8 flex h-[calc(100svh-347px)] min-h-[280px] w-full max-w-[560px] flex-col md:mb-sp-8 md:h-[calc(100svh-429px)]">
            <IntakeScheduler />
          </InputsContainer>
        </StepContent>
        <ActionsContainer>
          <ActionButton>Next</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
